/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsPortfolioRequest extends models.AppSecopsPortfolioBase {
    getFixupPrototypeFunction() { return AppSecopsPortfolioRequest.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsPortfolioRequest>): AppSecopsPortfolioRequest {
        let obj = Object.assign(new AppSecopsPortfolioRequest(), model);
        AppSecopsPortfolioRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsPortfolioRequest>): AppSecopsPortfolioRequest {
        if (!model) return null;
        return AppSecopsPortfolioRequest.newInstance(<AppSecopsPortfolioRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsPortfolioRequest) {
        if (!obj) return;

        models.AppSecopsPortfolioRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsPortfolioRequest): boolean {
        if (models.AppSecopsPortfolioBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AppSecopsPortfolioRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
